(function(angular) {
    'use strict';

    angular.module('appMessaging')

    /**
     *
     */
    .factory('clientPermissionsService',
        ['$http', '$q', 'jwtService', 'portalConfig',
            function ($http, $q, jwtService, portalConfig) {

        var urlBase = portalConfig.urlBase;

        var fac = {
        };

        return fac;

    }]);

})(window.angular);
